var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7914 12.6062C21.0355 12.397 21.1575 12.2924 21.2023 12.1679C21.2415 12.0586 21.2415 11.9391 21.2023 11.8298C21.1575 11.7053 21.0355 11.6007 20.7914 11.3914L12.3206 4.1308C11.9004 3.7706 11.6903 3.5905 11.5124 3.58609C11.3578 3.58226 11.2101 3.65018 11.1124 3.77006C11 3.90799 11 4.18473 11 4.7382V9.03346C8.86532 9.40691 6.91159 10.4886 5.45971 12.1127C3.87682 13.8833 3.00123 16.1748 3 18.5498V19.1618C4.04934 17.8977 5.35951 16.8753 6.84076 16.1647C8.1467 15.5383 9.55842 15.1671 11 15.0694V19.2595C11 19.8129 11 20.0897 11.1124 20.2276C11.2101 20.3475 11.3578 20.4154 11.5124 20.4116C11.6903 20.4072 11.9004 20.2271 12.3206 19.8669L20.7914 12.6062Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardGroup);
export default __webpack_public_path__ + "static/media/forwardGroup.b91a7fbc1802ab8ff538ce31e75fc3e5.svg";
export { ForwardRef as ReactComponent };